import React, { useState, useEffect } from "react";
import Navbar from "../Navigationbar/Navbar";
import { Outlet } from "react-router-dom";
import Sidebar from "../Navigationbar/Sidebar";

const DefaultLayout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };
  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isSidebarOpen]);
  return (
    <>
      <div className="h-screen bg-gray-100 overflow-hidden">
        <Navbar toggleSidebar={toggleSidebar} />
        <div className="flex">
          <div className="mt-[80px]">
            <Sidebar isOpen={isSidebarOpen} setSidebarOpen={setSidebarOpen} />
          </div>
          <main
            className={`flex-1 overflow-y-auto md:px-6 px-4 my-4 relative lg:ml-72 h-[calc(100vh-100px)] transition-opacity duration-300 md:pb-0 ${
              isSidebarOpen ? "opacity-50" : "opacity-100"
            }`}
          >
            {isSidebarOpen && (
              <div className="fixed inset-0 bg-black opacity-75 z-30"></div>
            )}
            <Outlet />
          </main>
        </div>
      </div>
    </>
  );
};

export default DefaultLayout;
